/** Versión única del módulo (sincronizar con backend/version.py). */
export const MODULE_VERSION = 'v0.12.2-restore-dashboard-visual';

export function isProductionFrontend() {
  if (process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'staging') {
    return true;
  }
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h.includes('spectra-metrics.com') && !h.includes('localhost')) return true;
  }
  return false;
}
